// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';
import {
  getSupplierCapabilities as getSupplierCapabilitiesRest,
  updateSupplierCapabilities as updateSupplierCapabilitiesRest,
  searchSuppliers as searchSuppliersRest
} from '../../utils/supplierRestApi';

/*-----------------------
    REQUEST USER ID
-------------------------*/
// export async function mySupplierCaps(id) {
//   // Format Query
//   const query = `query mySupplierCaps($id: ID ) { 
//     supplierSearch(ID: $id )
//     { 
//       suppliers{
//         supplierCapabilities{
//           cage,
//           company,
//           additionOptions,
//           alloy,
//           bizClass,
//           castings,
//           coreProcesses,
//           fsc,
//           lowVolume,
//           material,
//           qualityCerts,
//           rapidTooling,
//           simulationCapability
//         }
//       }
//     } 
//   }`;

//   // Variables
//   const variables = {
//     id,
//   };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

/*-----------------------
    UPDATE Caps
-------------------------*/

export async function updateCaps(supplierCaps, auth = null) {
  // Debug: Log the data being sent
  console.log('updateCaps - supplierCaps data being sent:', supplierCaps);
  console.log('minMaxDimensions:', supplierCaps.minMaxDimensions);

  try {
    // Use REST API instead of GraphQL
    const response = await updateSupplierCapabilitiesRest(supplierCaps, auth);
    console.log('REST API update response:', response);
    return response;
  } catch (error) {
    console.error('Error updating supplier capabilities via REST API:', error);
    throw error;
  }
}

export async function querySupplierCapsForautoComplete(criteria) {
  // Format query
  console.log('Search criteria:', criteria);
  const query = `query SupplierSearch($criteria: SupplierSearchInput ) { 
    supplierSearch(supplierCriteria: $criteria )
    { 
      suppliers {
        cage
        company
      }
      supplierAggs
    } 
  }`;

  const variables = { criteria: { ...criteria } };

  try {
    const response = await makeGraphQLRequest({
      query,
      variables,
    });
    console.log('GraphQL response:', response);
    return response.supplierSearch;
  } catch (error) {
    console.error('GraphQL request failed:', error);
    throw error;
  }
}

/**
 * Search suppliers using REST API
 * This provides an alternative to the GraphQL search
 */
export async function searchSuppliersRestAPI(criteria) {
  try {
    console.log('Searching suppliers with REST API, criteria:', criteria);
    const response = await searchSuppliersRest(criteria);
    console.log('REST search response:', response);
    return response;
  } catch (error) {
    console.error('REST search request failed:', error);
    throw error;
  }
}

export async function getSupplierCapabilities(cage, auth = null) {
  try {
    // Use REST API instead of direct fetch
    const response = await getSupplierCapabilitiesRest(cage, auth);
    console.log('Supplier capabilities response:', response);
    return response;
  } catch (error) {
    console.error('Error fetching supplier capabilities:', error);
    throw error;
  }
}

export async function getOrgNameAndCageCode(id) {
  // Format Query
  const query = `query organization($id: ID) {
    organization(id: $id) {      
      name, 
      cageCode,   
      }
    }`;

  // Variables
  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}



// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/EditSupplierCapsQL.js